import React from "react";
import { Text } from "@networkraildigitalfactory/components";
import styles from "./ViewReviewPrep.module.css";

const EoyPrepDetail = (props) => {
  const { detail } = props;
  const { interimComment } = detail;

  let interimFormattedMessage = interimComment;
  if (typeof interimComment === "string" && interimComment.includes("\n")) {
    interimFormattedMessage = interimComment.split("\n");
  }else if(!interimComment){
    interimFormattedMessage = "No prep completed."
  }

  return (
    <>
      <div className={styles.detail_row}>
        <Text wrapper="span" type="body" style={{ width: "75px" }}>
          Interim:
        </Text>
      </div>
      <div className={styles.detail_col}>
        <>
          {typeof interimFormattedMessage === "string" ? (
            <Text
              wrapper="p"
              style={{
                marginBottom: "1em",
                color: "#353535",
                textAlign: "justify",
                width: "calc(100% - 75px)",
              }}
            >
              {interimFormattedMessage}
            </Text>
          ) : (
            interimFormattedMessage?.map((line, index) => {
              return (
                <Text
                  wrapper="p"
                  key={index}
                  type="body"
                  style={{
                    marginBottom: "1em",
                    color: "#353535",
                    textAlign: "justify",
                    width: "calc(100% - 75px)",
                  }}
                >
                  {line}
                </Text>
              );
            })
          )}
        </>
      </div>
      </>
  );
};

export default EoyPrepDetail;
